import type { NavLinkProps } from 'react-router-dom'

import PaymentRequiredLink from './payment-required-link'
import { DynamicPricingFeatures } from '../../../store/types/billing'

export default function SmartPriceLink({
  ...props
}: NavLinkProps): JSX.Element {
  return (
    <PaymentRequiredLink
      allowed={DynamicPricingFeatures}
      feature="SmartPrice"
      {...props}
    />
  )
}
